export const model = {
  id: null,
  name: '',
  minimum_wage: null,
  currency_id: null,
  created_at: '',
  updated_at: '',
};
